import type { HorarioAcesso } from '@/types/database'

/**
 * Resultado da validacao de horario de acesso
 */
export interface AccessTimeValidation {
  /** Se o acesso e permitido no horario atual */
  isAllowed: boolean
  /** Mensagem para exibir ao usuario (se nao permitido) */
  message: string | null
  /** Hora atual no timezone UTC-4 */
  currentTime: string
  /** Horario permitido (se definido) */
  allowedWindow: HorarioAcesso | null
}

/**
 * Obtem a hora atual no timezone UTC-4 (Manaus)
 * @returns Hora no formato "HH:MM"
 */
export function getCurrentTimeUTC4(): string {
  const now = new Date()
  const utc4Offset = -4 * 60
  const utc4Time = new Date(now.getTime() + (utc4Offset + now.getTimezoneOffset()) * 60000)
  const hours = utc4Time.getHours().toString().padStart(2, '0')
  const minutes = utc4Time.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

/**
 * Converte string "HH:MM" para minutos desde meia-noite
 */
export function timeToMinutes(time: string): number {
  const parts = time.split(':').map(Number)
  const hours = parts[0] ?? 0
  const minutes = parts[1] ?? 0
  return hours * 60 + minutes
}

/**
 * Valida se o horario atual esta dentro da janela de acesso permitida
 */
export function validateAccessTime(horario: HorarioAcesso | null): AccessTimeValidation {
  if (!horario) {
    return {
      isAllowed: true,
      message: null,
      currentTime: getCurrentTimeUTC4(),
      allowedWindow: null,
    }
  }

  const currentTime = getCurrentTimeUTC4()
  const currentMinutes = timeToMinutes(currentTime)
  const startMinutes = timeToMinutes(horario.inicio)
  const endMinutes = timeToMinutes(horario.fim)
  const isAllowed = currentMinutes >= startMinutes && currentMinutes <= endMinutes

  return {
    isAllowed,
    message: isAllowed
      ? null
      : `Acesso nao permitido neste horario. Horario permitido: ${horario.inicio} as ${horario.fim}`,
    currentTime,
    allowedWindow: horario,
  }
}
